<template>
  <div id="home">
    <header v-if="toubu">
      <div header-wrap>
        <div menu-item>
          <img
            src="../assets/imgs/home/logo.png"
            style="width: 50px; margin-left: 30px"
          />
        </div>
        <div
          menu-item
          v-for="(cm, index) in curMenu"
          :key="index"
          v-bind:class="{ 'menu-active': cm.code == 'main' }"
          @click="navClick(cm, index)"
        >
          {{ cm.name }}
        </div>
      </div>
      <div header-user>
        <span header-user-type>{{ curUser.PRegionCode }}</span>
        <span header-user-filter>|</span>
        <span header-user-name>{{ curUser.UserName }}</span>
        <router-link to="/login">
          <img header-user-img src="../assets/imgs/home/power.png" alt />
        </router-link>
      </div>
    </header>
    <div class="home_main">
      <div container class="home_main_div">
        <!-- 个人信息 -->
        <div container-item="left" style="height: 580px">
          <div container-item-header>
            <div container-item-header-img>
              <el-upload
                class="upload-comps"
                :action="hostUrl + '/api/File/UploadSync'"
                :show-file-list="false"
                :on-success="importSuccess"
                :data="upData"
              >
                <img
                  v-if="curUser.AvatarUrl == null"
                  src="../assets/imgs/home/head.png"
                  alt
                />
                <img
                  v-if="curUser.AvatarUrl != null"
                  :src="hostUrl + '/api/file/preview/' + curUser.AvatarUrl"
                  alt
                />
              </el-upload>
            </div>
            <div container-item-name>
              <span>{{ curUser.UserName }}</span>
              <span name-block>{{ curUser.WorkRoleName }}</span>
            </div>
          </div>
          <div container-item-menu>个人信息</div>
          <div container-user-info>
            <table>
              <tr>
                <td>登录账号:</td>
                <td>{{ curUser.LoginId }}</td>
              </tr>
              <tr>
                <td>职务:</td>
                <td>{{ curUser.PRegionCode }}</td>
              </tr>
              <tr>
                <td>角色:</td>
                <td>{{ curUser.RegionName }}</td>
              </tr>

              <tr>
                <td>区域:</td>
                <td>{{ curUser.PPRegionName }}</td>
              </tr>
              <tr>
                <td>上级姓名:</td>
                <td>{{ curUser.ParentName == "" ? "未知" : curUser.ParentName }}</td>
              </tr>
              <tr>
                <td>手机号:</td>
                <td>{{ curUser.MobilePhone == "" ? "未知" : curUser.MobilePhone }}</td>
              </tr>
            </table>
          </div>
        </div>

        <div container-item="right">
          <div container-item-das-main v-if="curUser.HomePageType !== 100">
            <div container-item-das="left">
              <div
                v-if="HasDashBoard"
                style="padding-top: 14px; box-sizing: border-box; text-align: center"
              >
                <el-form :inline="true" size="mini" label-width="90px">
                  <el-form-item label="开始日期">
                    <el-date-picker
                      v-model="BeginDate"
                      type="month"
                      placeholder="选择日期"
                      value-format="yyyy-MM"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="结束日期">
                    <el-date-picker
                      v-model="EndDate"
                      type="month"
                      placeholder="选择日期"
                      value-format="yyyy-MM"
                    ></el-date-picker>
                  </el-form-item>
                </el-form>
              </div>
              <div v-if="HasDashBoard" style="display: flex; height: 240px">
                <div style="width: 44%">
                  <HomeEcharts1></HomeEcharts1>
                </div>
                <div style="width: 56%">
                  <HomeEcharts2></HomeEcharts2>
                </div>
              </div>
            </div>
            <div v-if="!HasDashBoard" container-item-das="right">
              <div container-item-das-link>
                <a
                  href="#"
                  target="_blank"
                  style="color: #000; text-decoration: underline"
                ></a>
              </div>
            </div>
          </div>
          <div container-item-das-main v-else style="margin-bottom: 10px">
            <div container-item-das="left" v-loading="QualityInformationLogin">
              <span
                style="
                  box-sizing: border-box;
                  width: 100%;
                  height: 40px;
                  padding: 0 10px;
                  border-bottom: 1px solid #ccc;
                  color: #333;
                  display: flex;
                  justify-content: space-between;
                  align-items: center; /* 关键：让内容在高度内居中 */
                "
              >
                <span style="color: red; flex: 1; font-weight: bold; font-size: 17px">
                  <span style="color: #333">质量报告事项提醒</span>(共{{
                    totalpmcount
                  }}条事项)
                </span>
                <el-button
                  type="success"
                  size="mini"
                  style="font-weight: normal"
                  @click="QualityDerive"
                  :loading="QualityDeriveLogin"
                  >导出</el-button
                >
              </span>

              <!-- <span> -->
              <el-table
                :data="tikudata"
                height="calc(100% - 40px)"
                border
                style="width: 100%"
                @cell-dblclick="(row) => trainClick(row.Id)"
              >
                <el-table-column
                  prop="ProjectName"
                  label="项目名称"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="CenterName"
                  label="中心名称"
                  show-overflow-tooltip
                  width="120"
                ></el-table-column>
                <el-table-column
                  prop="TemplateName"
                  label="报告类型"
                  show-overflow-tooltip
                  width="85"
                ></el-table-column>
                <el-table-column
                  prop="CallDate"
                  label="上传日期"
                  show-overflow-tooltip
                  width="95"
                ></el-table-column>
                <el-table-column
                  prop="CloseDate"
                  label="最晚关闭日期"
                  show-overflow-tooltip
                  width="105"
                ></el-table-column>
                <el-table-column
                  prop="Createby"
                  label="撰写者"
                  show-overflow-tooltip
                  width="64"
                ></el-table-column>
                <el-table-column
                  prop="Msg"
                  label="进度"
                  show-overflow-tooltip
                  width="95"
                ></el-table-column>
              </el-table>
              <!-- <div class="msg_boxDi">
                  <el-link
                    :underline="false"
                    @click="trainClick(item.Id)"
                    class="msg_boxDi_Div_Link"
                    v-for="(item, index) in this.tikudata"
                    :key="index"
                  >
                    {{ item.MsgTitle }}
                  </el-link>
                </div> -->
              <!-- </span> -->
            </div>
          </div>
          <div container-item-das-main>
            <div container-item-das="left">
              <div container-item-das-main>
                <!-- <div container-item-info-l1> -->
                <!-- 待办事项 -->
                <div class="Left_box_Dav">
                  <div das-title="info-sm" style="padding-left: 10px">
                    待办事项<i v-if="this.GetObjectListData.length" class="info_SM_I"
                      >(共{{ this.GetObjectListData.length }}条记录)</i
                    >

                    <span>
                      <i class="fa fa-clock-o" aria-hidden="true"></i>
                      {{ this.scheduleData }}
                    </span>
                  </div>
                  <div class="msg_boxDi">
                    <!-- <div class="msg_boxDi_Div"> -->
                    <el-link
                      :underline="false"
                      @click="trainClick(item.Id)"
                      class="msg_boxDi_Div_Link"
                      v-for="(item, index) in this.GetObjectListData"
                      :key="index"
                    >
                      <!-- {{ item.Msg.length > 50 ? item.Msg.slice(0, 100) + '...' : item.Msg }} -->
                      {{ item.MsgTitle }}
                    </el-link>
                  </div>
                  <!-- </div>       -->
                  <!-- <div info-l1-left-wrap>
                                    <div info-l1-left-r>
                                        <div das-title="info-sm">
                                            待办事项
                                            <span>
                                                <i class="fa fa-clock-o" aria-hidden="true"></i> {{ this.scheduleData }}
                                            </span>
                                        </div>
                                        <div>
                                            <div style="border: 1px red;width: 240px;height: px;">
                                                <div info-txt>
                                                    <a @click="trainClick">质量报告</a>
                                                    <a @click="trainClick">质量报告</a>

                                                </div>
                                            </div> -->
                  <!-- <div>质量报告明细<a @click="trainClick"></a></div> -->
                  <!-- <div>123456</div> -->
                  <!-- </div>
                                    </div>
                                 </div> -->
                </div>

                <!-- </div> -->
                <!-- <div container-item-info-l2 container-item-info="bottom">
                            <!-- 系统公告
                            <div info-l2-top :class="tableDatas.length > 0 ? '' : 'info_l2'">
                                <div info-l2-left-wrap style="width:100%;padding-left: 10px;">
                                    <div info-l1-left-r style="width:96%">
                                        <div das-title="info-sm">
                                            系统公告
                                            <span class="more" @click="moreClick">更多</span>
                                        </div>
                                        <div info-txt v-for="(item, ind) in tableDatas.slice(0, 3)" :key="ind"
                                            @click="FileMsg(item)" style="margin-left: 5px">
                                            <a target="_blank">
                                                <span class="title">{{ ind + 1 }}.{{ item.MsgTitle }}</span>
                                                <span style="float:right">{{ item.BeginTime.slice(0, 10) }}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                <!-- App下载 -->

                <!-- </div> -->
              </div>
              <!-- 公众号 -->
              <div container-item-das-main style="padding-top: 20px">
                <!-- 资料下载 -->
                <div info-l1-right>
                  <div info-l1-wrap>
                    <div das-title="info-sm">
                      资料下载
                      <span>
                        <i class="fa fa-clock-o" aria-hidden="true"></i> 2021-12-05
                      </span>
                    </div>
                    <div info-txt>
                      <!-- https://university.hengrui.com -->
                      <a
                        href="https://ptd-ms.cxish.com/help/%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97-CRC%E7%AB%AF20220428.pdf  "
                        target="_blank"
                        >系统操作指南</a
                      >
                      <a
                        href="https://ptd-ms.cxish.com/help/%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97-PM%E7%AB%AF20220428.pdf"
                        target="_blank"
                        >系统操作指南-PM端</a
                      >
                      <!-- <a href="https://dponlinedownload.parrowtech.com/soft/Moo0%20Video_v1.29%20Installer.zip"
                                target="_blank">视频压缩与裁剪工具下载</a>
                            <a href="https://dponlinedownload.parrowtech.com/soft/ChromeSetup.exe"
                                        target="_blank">世界最好浏览器下载</a>-->
                    </div>
                  </div>
                </div>
                <!-- 资料下载 -->
                <div info-l2-bottom>
                  <div info-l2-wrap>
                    <div class="erweiimg">
                      <img src="./../assets/imgs/home/app.png" alt />
                    </div>
                    <div style="margin-left: 10px">
                      <div das-title="info-sm" style="color: rgb(64, 158, 255)">
                        公众号
                        <span>
                          <i class="fa fa-clock-o" aria-hidden="true"></i> 2021-12-05
                        </span>
                      </div>
                      <div info-txt>
                        微信端公众号可扫描左边二维码进行关注，绑定帐后使用。谢谢！
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 公众号 -->
            </div>
          </div>
        </div>
      </div>
      <div bottom-suge>质量为先 中立为本</div>
    </div>

    <!-- 设置简介 -->
    <el-dialog
      title="设置简介"
      :visible.sync="setShow"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <div>
        <el-upload
          class="upload-demo"
          :action="hostUrl + '/api/File/UploadSync'"
          ref="upload"
          :before-upload="beforeUpload"
          :on-success="upScuccess"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <img
            style="width: 88%; margin: 10px 6% 0; display: block"
            :src="hostUrl + '/api/file/preview/' + curUser.RegistrationId"
            alt
          />
        </el-upload>
      </div>
    </el-dialog>
    <!-- 查看简介 -->
    <el-dialog
      title="查看简介"
      :visible.sync="getShow"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <img
        style="width: 100%"
        :src="hostUrl + '/api/file/preview/' + curUser.RegistrationId"
        alt
      />
    </el-dialog>
    <!-- 公告内容 -->
    <el-dialog
      title="公告内容"
      :visible.sync="showDetail"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <Infomation :Infomation="Infomation"></Infomation>
    </el-dialog>
    <!-- <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>-->
  </div>
</template>

<script>
import store from "../utils/storage";
import Infomation from "./public/Infomation";
import HomeEcharts1 from "./public/HomeEcharts1";
import HomeEcharts2 from "./public/HomeEcharts2";
import moment from "moment";

import {
  imgServerHost,
  getRoleOption,
  getBaseUrl,
  getFileMsgList,
  getFileMsgDetailList,
  GetDownFileById,
  SendMessage,
  ThumbsUp,
  UploadSync,
  GetObjectList,
  GetQualityRptList,
} from "../api/api";
// import * as XLSX from "xlsx";
// import {excel} from "../components/centeruser/templateExport/exportReport";
export default {
  name: "Home",
  components: { Infomation, HomeEcharts1, HomeEcharts2 },
  data() {
    return {
      totalpmcount: 0, //质量报告总条数
      tikudata: [], //质量报告数据
      QualityInformationLogin: false, //质量报告登录状态
      QualityDeriveLogin: false, //质量报告导出状态

      GetObjectListData: [], //质量报告对象
      scheduleData: moment().format("YYYY-MM-DD"),
      toubu: false,
      HasDashBoard: false, //true 带dashboard
      hostUrl: getBaseUrl(),
      curUser: store.getUserInfo(),
      curMenu: store.getCurMenu(),
      imgHost: imgServerHost(),
      upData: { uid: store.getUserInfo().UserId, attachDir: "head", ft: "head" },
      tableDatas: [],
      queryParams: {
        MsgType: 1,
        MsgTitle: "",
        BeginTime: "",
        EndTime: "",
        PageSize: 15,
        PageIndex: 1,
        IsAll: true,
        StartRow: 0,
        SearchKey: "",
        FileType: "",
        CCUsers: "",
        AllowComments: -1, //允许评论
        AllowSendRead: -1, //全员阅读
        IsFind: -1, //app首页
      },
      detailData: {},
      showDetail: false,
      showComment: false,
      message: "",
      count: 0,
      copyItem: {},
      Infomation: {},
      setShow: false,
      getShow: false,
      activeNames: ["6"],

      BeginDate: "",
      EndDate: "",
    };
  },
  mounted() {
    if (this.curUser.HomePageType == 100) {
      this.QualityInformation();
      // console.log('我打印了');
    }
    this.schedule();
    var ms = store.getMenus();
    if (ms.length === 0) this.$router.push({ path: "/login" });
    getRoleOption(false).then((res) => {});
    this.search();

    if (this.$route.path == "/home") {
      this.toubu = true;
    } else {
      this.toubu = false;
    }
  },
  methods: {
    importSuccess(response, file, fileList) {
      this.curUser.AvatarUrl = response.Data[0];
      store.setStore("cur-user-info", JSON.stringify(this.curUser));
    },
    beforeUpload(file) {
      // var index=file.name.lastIndexOf(".");
      // var suffix=file.name.substr(index+1);
      // if(this.filetypes && this.filetypes.length>0){
      //     if(this.filetypes.indexOf(suffix)<0){
      //         this.$message.error('该文件格式不支持!');
      //         return false;
      //     }
      // }
    },
    upScuccess(response, file, fileList) {
      this.curUser.RegistrationId = response.Data[0];
      store.setStore("cur-user-info", JSON.stringify(this.curUser));
    },
    //设置
    setUserClick() {
      this.setShow = true;
    },
    getUserClick() {
      if (this.curUser.RegistrationId) {
        this.getShow = true;
      }
    },
    search() {
      this.queryParams.UserId = this.curUser.UserId;
      this.queryParams.id = -1;
      getFileMsgList(this.queryParams).then((res) => {
        if (res.data.Code != 1) return;
        this.tableDatas = res.data.Data;
      });
    },
    moreClick() {
      this.$router.push({ path: "/FileManage" });
    },
    // trainClick(ID) {
    //     // this.$router.push({ path: '/MyJob' });
    //     // this.http://192.168.43.175:8081/#/reportQualityScreen?id=1506
    //     window.open(`http://192.168.43.175:8081/#/reportQualityScreen?id=${ID}`, '_blank');
    // },
    trainClick(item) {
      // this.$router.push({
      //   name: "reportQualityScreen",
      // });
      if (item == null) {
        window.sessionStorage.setItem("add", 1);
        window.sessionStorage.setItem("detailedData", JSON.stringify(item));

        let url = window.location.href.split("/");
        url[url.length - 1] = `reportQualityScreen?id=0`;
        window.open(url.join("/"));
      } else {
        GetQualityRptList({
          Types: 0,
          CallReportId: item,
          ProjectId: 0,
          ProjectName: "",
          CenterName: "",
          ProjectType: "",
          Indications: "",
          Stages: "",
          Progress: "",
          Steps: "",
          PMName: "",
          SWName: "",
          sw: "",
          DepName: "",
          sw1: "",
          sw2: "",
          sw3: "",
          PageIndex: 0,
          PageSize: 20,
          Skip: 0,
          RequetUrl: "",
        }).then((res) => {
          if (res.data.Code != 1) this.$message.error(res.data.Msg);
          window.sessionStorage.setItem("detailedData", JSON.stringify(res.data.Data[0]));

          let url = window.location.href.split("/");
          console.log(url, 999);

          url[url.length - 1] = `reportQualityScreen?id=${item}`;
          window.open(url.join("/"));
          this.loadingUp = false;
        });
      }
    },
    // 查看具体信息
    FileMsg(item) {
      this.Infomation = item;
      this.copyItem = item;
      this.showDetail = true;
    },
    closeDialog() {
      this.showDetail = false;
      this.copyItem = {};
      this.showComment = false;
      this.message = "";
    },
    navClick(val) {
      window.sessionStorage.setItem("code", val.code);
      window.sessionStorage.setItem("defaultUrl", val.defaultUrl);
      this.$router.push({
        name: "navHome",
        params: {
          code: val.code,
          defaultUrl: val.defaultUrl,
        },
      });
    },
    QualityInformation() {
      this.QualityInformationLogin = true;
      let params = {
        sw1: "100",
        sw2: "",
        sw3: "",
        objKey: "msg_gethomemessage",
      };
      GetObjectList(params).then((res) => {
        if (res.data.Code != 1) this.$message.error(res.data.Msg);
        // this.tikudata = res.data.Data.Table;
        this.tikudata = res.data.Data.Table.map((item) => {
          // 提取字段
          const project = item.ProjectName || ""; //项目名称

          const memo = item.CenterName || ""; //
          const callDate = item.CallDate || "";
          const user = item.Createby || "";

          // 生成 MsgTitle 字段
          const MsgTitle = `${project} : ${memo} 【${callDate}】 (${user})`;

          // 返回新的对象
          return {
            ...item,
            MsgTitle,
          };
        });

        // ProjectName,Memo10,CallDate,UserName

        this.totalpmcount = res.data.Data.Table.length; //总条数
        this.QualityInformationLogin = false;
      });
    },
    schedule() {
      let params = {
        sw1: "",
        sw2: "",
        sw3: "",
        objKey: "msg_gethomemessage",
      };

      GetObjectList(params).then((res) => {
        this.GetObjectListData = res.data.Data.Table.map((item) => {
          if (!item.Msg) return item;

          const projectMatch = item.Msg.match(/项目:(.*?);中心:/);
          const typeMatch = item.Msg.match(/【(.*?)】\s*(.*)/);

          const MsgTitle =
            projectMatch && typeMatch
              ? projectMatch[1] +
                item.Msg.substring(
                  item.Msg.indexOf("类型:"),
                  item.Msg.indexOf("】", item.Msg.indexOf("类型:")) + 1
                ) +
                `(${typeMatch[2]})`
              : item.Msg;

          return {
            ...item,
            MsgTitle,
          };
        });

        // console.log(this.GetObjectListData[0].Msg.substring(this.GetObjectListData[0].Msg.indexOf('类型:'), this.GetObjectListData[0].Msg.indexOf('】', this.GetObjectListData[0].Msg.indexOf('类型:')) + 1));
        // console.log();
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // formatDate(date) {
    //   return `${date.getFullYear()}-${this.add0(
    //     date.getMonth() + 1
    //   )}-${this.add0(date.getDate())}`;
    // },
    // QualityDerive() {
    //   this.QualityDeriveLogin = true;

    //   const tHeader = [
    //     "项目名称",
    //     "中心名称",
    //     "报告类型",
    //     "报告上传时间",
    //     "报告最晚关闭日期",
    //     "报告撰写者",
    //     "进度"
    //   ]; // 表头

    //   const filterVal = [
    //     "ProjectName",
    //     "CenterName",
    //     "type",
    //     "CallDate",
    //     "CloseDate",
    //     "Createby",
    //     "Msg"
    //   ]; // 字段映射

    //   // 处理数据
    //   let add = this.tikudata.map((item) => ({
    //     ProjectName: item.ProjectName,
    //     CenterName: item.CenterName,
    //     type: "", // 暂未提供 报告类型
    //     CallDate: item.CallDate,
    //     CloseDate: item.CloseDate, // 暂未提供 报告最晚关闭时间
    //     Createby: item.Createby,
    //     Msg: item.Msg
    //   }));

    //   // 转换为二维数组
    //   const data = add.map(row => filterVal.map(key => row[key] || ""));

    //   // 拼接表头 + 数据
    //   const worksheetData = [tHeader, ...data];

    //   // 生成工作表
    //   const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    //   // 自动列宽
    //   const colWidths = tHeader.map((h, i) => {
    //     const maxLength = Math.max(
    //       h.length,
    //       ...data.map(row => (row[i] ? String(row[i]).length : 0))
    //     );
    //     return { wch: maxLength + 2 };
    //   });
    //   worksheet["!cols"] = colWidths;

    //   // 生成工作簿
    //   const workbook = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(workbook, worksheet, "质量报告");

    //   // 导出 Excel
    //   XLSX.writeFile(
    //     workbook,
    //     `质量报告_${new Date().toISOString().slice(0, 10)}.xlsx`
    //   );

    //   this.QualityDeriveLogin = false;
    // } // 数据导出
    
    QualityDerive() {
  this.QualityDeriveLogin = true;
    import("../components/centeruser/templateExport/exportReport").then((excel) => {
  const tHeader = [
    "项目名称",
    "中心名称",
    "报告类型",
    "报告上传时间",
    "最晚关闭日期",
    "报告撰写者",
    "进度",
  ];
  const filterVal = [
    "ProjectName",
    "CenterName",
    "TemplateName",
    "CallDate",
    "CloseDate",
    "Createby",
    "Msg",
  ];
  // 先生成完整数据
  const add = this.tikudata.map(item => ({
    ProjectName: item.ProjectName,
    CenterName: item.CenterName,
    TemplateName: item.TemplateName,
    CallDate: item.CallDate,
    CloseDate: item.CloseDate,
    Createby: item.Createby,
    Msg: item.Msg,
  }));

  // 格式化成二维数组
  const data = this.formatJson(filterVal, add).map(row =>
    row.map(i => i || "") // 空值处理
  );

  // 导出一次
  excel.export_json_to_excel({
    header: tHeader,
    data,
    filename: "质量报告事项提醒_"+'',
    autoWidth: true,
    bookType: "xlsx",
    myRowFont: "2",
  });

  this.QualityDeriveLogin = false;
});
    }, //数据导出
  },
};
</script>

<style lang="less" scoped>
@import "../assets/css/home.css"; //带dashboard
// @import "../assets/css/home2.css";
#home {
  height: 100%;
  overflow: auto;
  .home_main {
    height: 85%;
    .home_main_div {
      height: 100%;
    }
  }
}
.info_SM_I {
  color: red;
  font-style: normal;
  margin-left: 10px;
}
.line-div {
  width: 12rem;

  height: 4rem;

  /* border-bottom: 0.15rem solid #19e05b; */

  /* border: 2px solid #000000; */

  position: absolute;

  text-align: center;

  margin-left: 50%;

  margin-top: -70px;

  -webkit-transform: rotate(25deg);

  -moz-transform: rotate(25deg);
  color: rgb(216, 22, 135);
  font-weight: 900;

  filter: progid:DXImageTransform.Microsoft.BasicImage(Rotation=0.45);
}

.more {
  display: inline-block;
  width: 46px;
  line-height: 30px;
  font-size: 14px;
  text-align: center;
  // color: blue;
  // text-decoration:underline;
  // margin-left: 5px;
  // box-sizing: border-box;
}

.title {
  display: inline-block;
  width: 65%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: underline;
}

.tags {
  margin-left: 10px;
  display: inline-block;
  padding: 3px 14px;
  border-radius: 16px;
  color: #fff;
  font-size: 12px;
  background: #1989fa;
}

.Img_box {
  margin-left: 55px;
  margin-top: 15px;
  padding-left: 10px;
}

.Img_box img {
  vertical-align: bottom;
}

.Img_box span {
  display: inline-block;
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.box {
  margin-top: 15px;
  position: relative;
}

.box2 {
  display: flex;
  justify-content: space-between;
  /* background: antiquewhite; */
  line-height: 24px;
  padding: 3px 8px;
  box-sizing: border-box;
}

.icon {
  font-size: 20px;
  /* vertical-align: middle; */
}

.comments {
  position: relative;
  background: #fff;
  width: 96%;
  left: 0;
  top: 0px;
  height: 140px;
  padding: 0 10px;
}

.msg_box {
  margin-top: 10px;
}

.confrim_btn {
  margin-top: 15px;
}

.cancel {
  margin-left: 40px;
}

.detail-item {
  max-height: 180px;
  overflow: auto;
  margin-top: 3px;
}

.info_l2 {
  align-items: normal;
  padding-top: 36px;
  /* background: aqua; */
  box-sizing: border-box;
}

.info_down {
  font-size: 12px;
  line-height: 24px;
}

/deep/ .el-collapse-item__header {
  padding-left: 8px;
  box-sizing: border-box;
  font-weight: 600;
}

/deep/ .el-collapse-item__content {
  padding-bottom: 10px;
}

.erweiimg img {
  margin-top: 45px;
  width: 85px;
  height: 85px;
}
.Left_box_Dav {
  width: 100%;
  height: 100%;
}
.msg_boxDi {
  // display: flex;
  padding-left: 10px;
  max-height: 87%;
  min-height: 83%;
  // height: 73%;
  // .msg_boxDi_Div{
  //     width: 100%;
  //     height: 100%;
  overflow-y: auto;
  //     flex: 1;
  //     justify-content:flex-start;
  .msg_boxDi_Div_Link {
    width: 100%;
    text-align: left;
    display: block;
    color: #000;
  }
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue